import React, { useState } from 'react';

export default function Faq() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <style>
        {`
        
.pq-section.pq-style-1.text-center {
  text-align: center;
  margin-bottom: 40px;
}

.pq-section-sub-title {
  font-size: 18px;
  color: #666;
  display: block;
  margin-bottom: 10px;
}

.pq-section-title {
  font-size: 28px;
  color: #333;
  font-weight: 600;
}


.pq-accordion-block {
  width: 100%;
}

.pq-accordion-box {
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 10px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.pq-accordion-box.active {
  border-color: #239857;
}

.pq-ad-title {
  padding: 15px;
  background-color: #f9f9f9;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ad-title-text {
  font-size: 16px;
  color: #333;
  margin: 0;
  flex: 1;
}

.pq-accordion-details {
  padding: 0 15px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
}

.pq-accordion-details.open {
  padding: 15px;
  max-height: 500px; 
}

.pq-detail-text {
  font-size: 14px;
  color: #555;
  line-height: 1.6;
  margin: 0;
}

.fa {
  font-size: 14px;
  color: #239857;
  transition: transform 0.3s ease;
}

.fa-chevron-down {
  transform: rotate(0deg);
}

.fa-chevron-up {
  transform: rotate(180deg);
}
.pq-accordion-block .pq-accordion-box .pq-accordion-details {
  padding: 0 20px  !important;
  border: 1px solid var(--grey-color);
  border-top: 0;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}
`}
      </style>
      <section className="faq">
        <div className="container py-4">
          <div className="row">
           <div className="col-md-7">
            <div className="pq-section pq-style-1 text-center">
               <h2 className="pq-section-title">Frequently Asked Questions (FAQ’s)</h2>
            </div>
            
            <div className="col-xl-12 mt-xl-0 ps-xl-3">
              <div className="pq-accordion-block mt-4">
                {[ 
                  { question: "What is Endoscopic DCR surgery?", answer: "Endoscopic DCR (Dacryocystorhinostomy) is a minimally invasive procedure used to treat blocked tear ducts. The surgeon creates a new tear drainage pathway through the nose using an endoscope, without any external cuts. It helps reduce watering eyes, infections, and constant tearing." },
                  { question: "Who needs Endoscopic DCR surgery?", answer: "Patients with chronic watery eyes, repeated eye infections, blocked tear ducts (nasolacrimal duct obstruction), or swelling near the eye corner may need this surgery. When eye drops or medical treatment no longer help, DCR is the most effective long-term solution." },
                  { question: "How is Endoscopic DCR different from conventional DCR?", answer: "Endoscopic DCR is performed through the nose, leaving no external scar, causing less pain and faster recovery. Traditional DCR involves a skin incision near the eye. Endoscopic DCR is preferred for cosmetic reasons and offers similar or better success rates." },
                  {question: "What is the recovery time after Endoscopic DCR surgery?", answer: "Most patients recover within 1–2 weeks. Mild nasal bleeding, congestion, or tearing may occur temporarily. Normal activities can usually be resumed in a few days. Follow-up visits ensure the new tear passage stays open and heals properly."},
                  {question: "Is Endoscopic DCR surgery safe and effective?", answer: "Yes, it is considered very safe when performed by an experienced ENT surgeon. Success rates are high, and complications are rare. The minimally invasive approach improves comfort, speeds healing, and keeps cosmetic appearance intact."}
                ].map((item, index) => (
                  <div className={`pq-accordion-box ${activeIndex === index ? 'active' : ''}`} key={index}>
                    <div className="pq-ad-title" onClick={() => toggleAccordion(index)}>
                      <h4 className="ad-title-text">
                        {item.question}
                        <i className={`fa ${activeIndex === index ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                      </h4>
                    </div>
                    <div className={`pq-accordion-details ${activeIndex === index ? 'open' : ''}`}>
                      <p className="pq-detail-text">{item.answer}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
             </div>
            <div className="col-md-5 m-auto">
                  <div className="card shadow-lg">
                     <iframe 
  width="100%" 
  height="315"
  src="https://www.youtube.com/embed/rFPeW_FPRbw"
  title="YouTube Shorts video"
  frameborder="0"
  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
  allowfullscreen>
</iframe>
                  <div class="p-3"><h5 class="text-success mb-0">Patient Testimonial at MedFirst ENT Centre. Successful Endoscopic DCR Surgery.</h5></div>
          </div>
              </div>
          </div>
        </div>
      </section>
    </div>
  );
}
